import type { Contact } from "@/features/contact/types";

import { CONTACT_VISIBILITY, type ContactViewer } from "@/types/role";

// The server's contact wall, as the mock server applies it: a limited role sees
// a contact assigned to them, and on `teams` one assigned to a team they are
// in. The app itself never decides this; the real server does.
export const isContactVisible = (
  contact: Partial<Pick<Contact, "assignedUserId" | "assignedTeamId">>,
  viewer: ContactViewer,
): boolean => {
  if (viewer.contactVisibility === CONTACT_VISIBILITY.ALL) return true;
  if (!viewer.userId) return false;
  if (contact.assignedUserId === viewer.userId) return true;

  return (
    viewer.contactVisibility === CONTACT_VISIBILITY.TEAMS &&
    !!contact.assignedTeamId &&
    viewer.teamIds.includes(contact.assignedTeamId)
  );
};
